import { useEffect, useState } from 'react';

/**
 * Se a media query casa agora, acompanhando as mudanças (girar o celular, redimensionar a janela).
 *
 * Existe para decidir o que MONTAR, que é diferente de esconder. `hidden lg:block` só esconde: o
 * React monta o componente do mesmo jeito, e um `lazy()` lá dentro dispara o download do chunk
 * numa tela que nunca vai mostrá-lo. Foi assim que o recharts descia inteiro para o celular sem o
 * gráfico da Tendência aparecer. Quando o que muda é só o visual, as classes do Tailwind continuam
 * sendo o caminho.
 *
 * Sem `window.matchMedia` (Jest/jsdom) devolve `false` — quem usa escolhe a query de modo que
 * `false` seja o lado mais leve.
 */
export function useMediaQuery(query) {
	const [casa, setCasa] = useState(() => lerMediaQuery(query));

	useEffect(() => {
		if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return undefined;

		const lista = window.matchMedia(query);
		const atualizar = () => setCasa(lista.matches);

		// A query pode ter mudado entre a primeira renderização e o efeito.
		atualizar();

		// Safari anterior ao 14 só conhece o addListener, já obsoleto.
		if (typeof lista.addEventListener === 'function') {
			lista.addEventListener('change', atualizar);
			return () => lista.removeEventListener('change', atualizar);
		}
		lista.addListener(atualizar);
		return () => lista.removeListener(atualizar);
	}, [query]);

	return casa;
}

function lerMediaQuery(query) {
	if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
	return window.matchMedia(query).matches;
}
